
import { defineComponent } from 'vue'
export default defineComponent({
  emits: [],
  name: 'InvoiceButton',
  props: {},
  setup(props, { emit }) {
    return {}
  }
})
